import React from 'react';

const PalaceIcon = (props) => {
  return (
    <img
      alt="Góra"
      src="/static/images/icons/tourist_attractions/palace.svg"
      {...props}
    />
  );
};

export default PalaceIcon;
